var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip"},[_c('div',{staticClass:"tooltipText"},[_c('div',{attrs:{"aria-label":_vm.tooltipText}})])])}
var staticRenderFns = []

export { render, staticRenderFns }